import React from 'react'
import { LCSLHPTIGroupedHeader, LCSLHPTIHeader, LCSLHPTIRow } from '../hooks/useLCSLHPTITablaValor';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import { OperacionLCSLHPTITablaValorFields } from '../types/fields';
import { numberFormatter } from 'src/utils/formatters/numberFormatter';

interface LCLSHPTITablaValoresProps {
  headers: LCSLHPTIGroupedHeader[];
  rows: LCSLHPTIRow[];
  limiteAgregadoPosicionComprada?: string;
  limiteAgregadoPosicionVendida?: string;
}

const LCLSHPTITablaValores = ({ headers, rows, limiteAgregadoPosicionComprada, limiteAgregadoPosicionVendida }: LCLSHPTITablaValoresProps) => {
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              sx={{ backgroundColor: 'grey.100', fontWeight: 'bold', borderRight: 1, borderColor: 'divider' }}
            >
              Instrumento
            </TableCell>
            {headers.map((group) => (
              <TableCell
                key={group.agrupacion}
                align="center"
                colSpan={group.columnas.length}
                sx={{ backgroundColor: 'grey.100', fontWeight: 'bold', borderRight: 1, borderColor: 'divider' }}
              >
                {group.agrupacion}
              </TableCell>
            ))}
          </TableRow>

          <TableRow>
            <TableCell sx={{ borderRight: 1, borderColor: 'divider', backgroundColor: 'grey.50' }} />
            {headers.flatMap(group =>
              group.columnas.map(col => (
                <TableCell
                  key={col.codOperacionTipo}
                  align="center"
                  sx={{ fontWeight: 'medium', fontSize: '0.75rem', borderRight: 1, borderColor: 'divider', minWidth: 120, whiteSpace: 'normal', lineHeight: 1.2 }}
                >
                  {col.descOperacionTipo}
                </TableCell>
              ))
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.rowKey}
              hover>
              <TableCell
                sx={{ fontWeight: 'bold', backgroundColor: 'grey.50', borderRight: 1, borderColor: 'divider' }}
              >
                {row.descInstrumento}
              </TableCell>
              {headers.flatMap(group =>
                group.columnas.map(col => {
                  const celda = row.celdas[col.codOperacionTipo];

                  return (
                    <TableCell
                      key={`${row.codInstrumento}-${col.codOperacionTipo}`}
                      align="center"
                      sx={{ borderRight: 1, borderColor: 'divider' }}
                    >
                      <Typography variant="body2">
                        {celda[OperacionLCSLHPTITablaValorFields.TipoSelector] === 'limite_credito' && celda[OperacionLCSLHPTITablaValorFields.Valor]
                          ? celda[OperacionLCSLHPTITablaValorFields.Valor]
                          : celda[OperacionLCSLHPTITablaValorFields.Valor]}
                      </Typography>
                    </TableCell>
                  );
                })
              )}
            </TableRow>


          ))}
          {
            (limiteAgregadoPosicionComprada && limiteAgregadoPosicionVendida) && (
              <TableRow>
                <TableCell sx={{ backgroundColor: 'grey.100', fontWeight: 'bold', borderRight: 1, borderColor: 'divider' }}>Límite Agregado</TableCell>

                <TableCell sx={{ p: 1, backgroundColor: 'grey.25', borderRight: 1, borderColor: 'divider' }} align="center">
                  {limiteAgregadoPosicionComprada}
                </TableCell>

                <TableCell sx={{ p: 1, borderRight: 1, borderColor: 'divider' }} align="center">
                  {limiteAgregadoPosicionVendida}
                </TableCell>
                <TableCell colSpan={99} sx={{ backgroundColor: 'grey.25', opacity: 0.5 }} />
              </TableRow>
            )
          }

        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default LCLSHPTITablaValores